let $nav;
let $items;

function cacheDOM() {
  $nav = document.querySelector('.js-nav-product-variants');
  if ($nav) {
    $items = [...$items = $nav.querySelectorAll('[data-kg-value]')];
  }
}

function injectBadge() {
  const $badge = Object.assign(
    document.createElement('a'),
    {
      className: 'badge-best-value',
      innerText: 'Best Value',
    },
  );
  const $sorted = $items.sort((a, b) => {
    const aKg = parseInt(a.dataset.kgValue, 10);
    const bKg = parseInt(b.dataset.kgValue, 10);
    return aKg - bKg;
  });
  if ($sorted && $sorted[0]) {
    if ($sorted[0].dataset?.variantHref) {
      $badge.href = $sorted[0].dataset.variantHref;
    }
    $sorted[0].appendChild($badge);
  }
}

export default function init() {
  cacheDOM();
  if ($nav && $items && $items.length) injectBadge();
}
